import { observer } from 'mobx-react';
import { FC, ReactElement, memo, useMemo } from 'react';
import { mealChoiceEditModalStore } from '../../store/mealChoiceEditModalStore';
import { MealChoiceEditModalItemPicker } from '../MealChoiceEditModalItemPicker/MealChoiceEditModalItemPicker';
import { MealChoiceEditModalItemPrice } from '../MealChoiceEditModalItemPrice/MealChoiceEditModalItemPrice';
import { localeStore } from 'src/mobx/localesStore';
import { IProductV4Size } from 'src/types/product';
import { getTranslate } from 'src/utils/helpers';
import './style.scss';
import { IMealItem } from '~/types/combo';

interface IProps {
  size: IProductV4Size;
}

export const MealEditChoiceModalItem: FC<IProps> = memo(
  observer((props: IProps): ReactElement | null => {
    if (!props.size.id) return null;

    const itemBySize = useMemo((): IMealItem | undefined => {
      return mealChoiceEditModalStore.getItemBySize(props.size.id || 0);
    }, [props.size.id, mealChoiceEditModalStore.items]);

    return (
      <div className="mt-6">
        <p className="meal-edit-choice-modal-item__size-title letter-spacing-12 text-elipsis">
          {localeStore.t('txt_size') + ': ' + getTranslate(props.size.name)}
        </p>

        <MealChoiceEditModalItemPicker item={itemBySize} sizeId={props.size.id} />
        <MealChoiceEditModalItemPrice item={itemBySize} sizeId={props.size.id} />
      </div>
    );
  })
);
